webpackJsonp([263791100135453],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h1",
	      null,
	      "\u041E\u0431\u043E \u043C\u043D\u0435"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "\u041C\u0435\u043D\u044F \u0437\u043E\u0432\u0443\u0442 \u0414\u0435\u043D\u0438\u0441 \u0411\u043E\u0440\u043E\u0434\u0438\u043D, \u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0441\u0442 \u0438 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444. \u0416\u0438\u0432\u0443 \u0432 \u041C\u043E\u0441\u043A\u0432\u0435. \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0443\u044E\u0441\u044C \u0434\u0438\u0437\u0430\u0439\u043D\u043E\u043C, \u0445\u043E\u0436\u0443 \u043D\u0430 \u0432\u0441\u0442\u0440\u0435\u0447\u0438 \u0438 \u043C\u0438\u0442\u0430\u043F\u044B \u043F\u043E \u0444\u0440\u043E\u043D\u0442\u044D\u043D\u0434\u0443 \u0438 \u0434\u0438\u0437\u0430\u0439\u043D\u0443. \u0412 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043A\u0430\u0442\u0430\u044E\u0441\u044C \u043D\u0430 \u0432\u0435\u043B\u043E\u0441\u0438\u043F\u0435\u0434\u0435 \u0438 \u043A\u043E\u043D\u044C\u043A\u0430\u0445, \u043F\u0443\u0442\u0435\u0448\u0435\u0441\u0442\u0432\u0443\u044E \u043F\u043E \u0433\u043E\u0440\u043E\u0434\u0430\u043C. \u0422\u0430\u043A \u0436\u0435 \u0437\u0430\u043D\u0438\u043C\u0430\u044E\u0441\u044C \u0441\u044A\u0435\u043C\u043A\u043E\u0439 ",
	      _react2.default.createElement(
	        "a",
	        { href: "//tour-360.ru/" },
	        "360 \u043F\u0430\u043D\u043E\u0440\u0430\u043C."
	      )
	    ),
	    _react2.default.createElement(
	      "h3",
	      null,
	      "\u041E \u0447\u0435\u043C \u044D\u0442\u043E\u0442 \u0441\u0430\u0439\u0442"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "\u042D\u0442\u043E \u0441\u0430\u0439\u0442 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u043B\u0441\u044F \u043C\u043D\u043E\u044E \u0434\u043B\u044F \u0441\u0435\u0431\u044F, \u0441 \u0446\u0435\u043B\u044C\u044E \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E. \u0421\u043A\u043E\u0440\u0435\u0435 \u043E\u043D \u043F\u043E\u0445\u043E\u0436 \u043D\u0430 \u0444\u043E\u0442\u043E\u0430\u043B\u044C\u0431\u043E\u043C \u0447\u0435\u043C \u043D\u0430 \u0431\u043B\u043E\u0433 \u0432 \u043F\u0440\u0438\u0432\u044B\u0447\u043D\u043E\u043C \u043F\u043E\u043D\u0438\u043C\u0430\u043D\u0438\u0438. \u0417\u0434\u0435\u0441\u044C \u044F \u0431\u0443\u0434\u0443 \u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u044F\u043C\u0438 \u0441 \u0440\u0430\u0437\u043D\u044B\u0445 \u0441\u043E\u0431\u044B\u0442\u0438\u0439 \u0438 \u043F\u0443\u0442\u0438\u0448\u0435\u0441\u0442\u0432\u0438\u0439."
	    ),
	    _react2.default.createElement(
	      "h3",
	      null,
	      "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "\u0421\u043E \u043C\u043D\u043E\u0439 \u043C\u043E\u0436\u043D\u043E \u0441\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F \u043F\u043E \u043F\u043E\u0447\u0442\u0435 ",
	      _react2.default.createElement(
	        "a",
	        { href: "mailto:BorodinDK@gmail.com" },
	        "BorodinDK@gmail.com"
	      ),
	      " \u0438\u043B\u0438 \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 ",
	      _react2.default.createElement(
	        "a",
	        { href: "tell" },
	        "+7\xA0985\xA0987\xA038\xA000"
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-48486d479d21c5e97de0.js